<script setup lang="ts">
import Card from "@/shared/components/card/card.vue";
import AppCard from "@/abilities/dashboard/pages/widgets/apps/app-card.vue";
import { WidgetContext } from "@/shared/environment/widgets/widget-context";
import { useContextElements } from "@/shared/ui-extensions/context-elements.ts";
import { GuiElementTypes, GuiElementView } from "@/shared/ui-extensions/context.types.ts";

defineProps<{
    widgetContext: WidgetContext;
}>();

const { elements, openUrl } = useContextElements(GuiElementTypes.cards, { view: GuiElementView.dashboard });
</script>

<template>
    <Card
        v-if="elements.length > 0"
        class="apps-widget-card"
        title-icon="fa-regular fa-grid-2 light-border-color"
        :title="$t('dashboard.Apps & Links')"
        :show-footer="false"
    >
        <div class="apps-grid" data-qs="apps-widget-grid">
            <AppCard
                v-for="app in elements"
                :key="app.id"
                :test-id="`apps-widget-card-${app.id}`"
                :title="app.title"
                :description="app.text"
                :icon="app.symbol"
                :disabled="app.disabled"
                @click="!app.disabled && openUrl(app.url, app.openInCurrentTab)"
            />
        </div>
        <template #close></template>
    </Card>
</template>

<style lang="scss" scoped>
.apps-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: $spacing-l;

    // Breakpoint sm (600px) - 1023px
    @media (max-width: 1023px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    // 450px - 599px
    @media (max-width: 599px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    // below 450px
    @media (max-width: 449px) {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>
